<template>
  <div class="edit">
    <Edit />
  </div>
</template>

<script>
// @ is an alias to /src
import Edit from "@/components/Edit.vue";

export default {
  name: "EditRoute",
  components: {
    Edit
  }
};
</script>
